// React
import { useState, useEffect } from "react";

// MUI
import { Box, IconButton, Popover } from "@mui/material";

// Icons
import BrowserNotSupportedRoundedIcon from "@mui/icons-material/BrowserNotSupportedRounded";
import SquareRoundedIcon from "@mui/icons-material/SquareRounded";

type AddCellIssuesProps = {
	anchorEl: HTMLElement | null;
	open: boolean;
	onChangeAction: (color: string | null) => void;
	onCloseAction: () => void;
};

export default function AddCellIssues(props: Readonly<AddCellIssuesProps>) {
	const [open, setOpen] = useState(false);
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const handleChange = (color: string | null) => {
		if (props.onChangeAction) {
			props.onChangeAction(color);
		}
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
		setOpen(false);
		if (props?.onCloseAction) {
			props.onCloseAction();
		}
	};

	useEffect(() => {
		let isOpen = false;
		if (props?.anchorEl) {
			isOpen = props?.open || false;
		}

		setOpen(isOpen);
		setAnchorEl(props?.anchorEl || null);

		return () => {
			setOpen(false);
			setAnchorEl(null);
		};
	}, [props]);

	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			style={{ width: "87px !important" }}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
			transformOrigin={{
				vertical: "top",
				horizontal: "left",
			}}
			onClose={handlePopoverClose}
			disableRestoreFocus
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					columnGap: 0.5,
					ml: 0.5,
					mr: 0.5,
					mt: -0.2,
				}}
			>
				<Box>
					<IconButton
						sx={{ color: "red", width: "9px", height: "9px", borderRadius: "2px" }}
						aria-label="checked"
						component="span"
						onClick={() => handleChange(null)}
					>
						<BrowserNotSupportedRoundedIcon fontSize="small" />
					</IconButton>
				</Box>
				<Box>
					<IconButton
						sx={{ color: "#009245", width: "9px !important", height: "9px !important", borderRadius: "2px !important" }}
						aria-label="checked"
						component="span"
						onClick={() => handleChange("#009245")}
					>
						<SquareRoundedIcon fontSize="small" />
					</IconButton>
				</Box>
				<Box>
					<IconButton
						sx={{ color: "#f15a24", width: "9px", height: "9px", borderRadius: "2px" }}
						aria-label="checked"
						component="span"
						onClick={() => handleChange("#f15a24")}
					>
						<SquareRoundedIcon fontSize="small" />
					</IconButton>
				</Box>
				<Box>
					<IconButton
						sx={{ color: "#2e4a9e", width: "9px", height: "9px", borderRadius: "2px" }}
						aria-label="checked"
						component="span"
						onClick={() => handleChange("#2e4a9e")}
					>
						<SquareRoundedIcon fontSize="small" />
					</IconButton>
				</Box>
			</Box>
		</Popover>
	);
}
